<template>
  <div>
    <section class="orep-header mont">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img src="../../public/assets/images/logo@2.png" class="logo" alt="Logo">
        <span class="logo-text text-uppercase"></span>
      </section>
    </section>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form  action @submit.prevent="next">
            <article class="form-heading title-section auth-title-section form-section flex">
              <h1 class="form-title">Forget Password</h1>
              <img
                src="../../public/assets/images/padlock.png"
                class="title-section-img form-title-img ops-section-img padlock-img"
                alt="background image"
              >
            </article>
            <article class="auth-section">
              <p class="before">
                OREP includes your Risk ID in renewal reminders.
              </p>
              <p class="mb-5">
                If you can't locate your Risk ID or you're having trouble logging in, please enter your email and Click Submit and you'll receive an email with further instructions.
              </p>
              <div class="row align-items-center submit-row">
                <div class="col-md-3">Your Email:</div>
                <div class="col-md-6">
              <input                       name="email"
                                             autocomplete="email"
                                             class="orep-text-input auth-input mb-0 w-100"  v-model="customerDetail.email"
                         v-validate="'required|email'"
                         @input="validateBeforeSubmit()">
                </div>
                <div class="col-md-3">
                  <button  :disabled="!state.pageTwoIsValid"
                          :class="{submitDisabled: !state.pageTwoIsValid}" class="submit-btn mont spaced mr-5"  @click="navigateToNext('login')" >
                    SUBMIT
                  </button>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "forgetPassword",
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    customerDetail() {
      return this.$store.state.customerDetail.customerDetail;
    },
    state() {
      return this.$store.state.customerDetail;
    },
    errorMsg() {
      return this.$store.state.customerDetail.errorMsg;
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000,
          });
        }
      },
    },
  },
  methods: {
    prev() {
      this.$router.push({
        name: "login",
      });
    },

    navigateToNext(routeName) {
      this.sendEmail(routeName);
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = false;
      });
    },

    sendEmail(routeName = 'login') {
      this.loading = true;
      this.$store.dispatch('customerDetail/sendEmail', {routeName});
    },
  },

  mounted() {
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500,
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    },
  },
  components: {},
};
</script>

<style scoped>
  .auth-section {
    max-width: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto 70px;
    padding: 1rem;
  }
  .submit-btn {
    width: 130px;
    text-align: center;
    height: 46px;
    border-radius: 5px;
    background-color: #5f6273;
    font-size: 16px;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
    border: 0;
    cursor: pointer;
  }
  .submit-row > div {
    margin-bottom: 1rem;
  }
</style>

